import React, { ReactElement, ReactNode, useState } from "react";
import UserDetailsContext, { defaultUserDetails } from "./user-details-context";

const setUserDetailsProviderValue = (
  setUserDetails: (userDetails: typeof defaultUserDetails["userDetails"]) => void,
  userDetails: typeof defaultUserDetails["userDetails"]
): typeof defaultUserDetails => ({
  userDetails,
  setUserDetails
});

const UserDetailsProvider = ({ children }: { children: ReactNode }): ReactElement => {
  const [userDetails, setUserDetails] = useState({
    voornaam: "",
    tussenvoegsels: "",
    achternaam: "",
    roepnaam: null,
    voorletters: "",
    telefoon: null,
    geslacht: "Man",
    telefoonWerk: null,
    telefoonMobiel: null,
    email: "",
    functie: null,
    platformId: null,
    klantId: null,
    isActief: true,
    klantdossierRechtenVestigingen: null,
    klantdossierRechtenOrganisatie: null,
    medewerkerId: "",
    organisatieId: ""
  });

  const val = setUserDetailsProviderValue(setUserDetails, userDetails);
  return <UserDetailsContext.Provider value={val}>{children}</UserDetailsContext.Provider>;
};

export default UserDetailsProvider;
